import request from '@/utils/request'

// 获取仪表盘统计数据 - 注意后端路径是 /admin/dashboard
export function getDashboardData() {
  return request({
    url: '/dashboard',
    method: 'get'
  })
}

// 获取仪表盘统计信息
export function getDashboardStat() {
  return request({
    url: '/dashboard/stat',
    method: 'get'
  })
}

// info 函数 - 用于 dashboard 页面
export function info() {
  return request({
    url: '/dashboard',
    method: 'get'
  })
}
